<template>
    <div>
        <home-header  @getCity="getCity"></home-header>

        <div class="new_wrapper wrapper">
            <!--行业新闻-->
            <div class="wrap">
                <img src="../assets/image/news/news_title.png" alt="" class="title_img"/>

                <!-- 轮播-->
                <div class="swiper_box">
                    <!-- 左按钮-->
                    <div class="img_box">
                        <img src="../assets/image/coms/left.png" alt="" class="btn_img" @click="imageClick('left')"
                             v-if="currPage>1"/>
                    </div>
                    <!-- 中间轮播-->

                    <div class="banner_box" v-if="news_data.length">
                        <el-carousel arrow="never" indicator-position="none" :autoplay="false" ref="banner"
                                     class="banner">
                            <el-carousel-item
                                v-for="(item, index) in Math.ceil(news_data.length / 2)"
                                :key="index"

                            >
                                <div v-for="(el, ind) in news_data.slice((item - 1)*2, item*2)" :key="ind" class="news_item"
                                     @click="clk_info(el)">
                                    <img :src="el.thumb">
                                    <div>
                                        <p class="theme_title">{{el.title}}</p>
                                        <p class="text-overflow">{{el.describe}}</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div v-else class="wait_box">敬请期待...</div>
                    <!-- 右按钮-->
                    <div class="img_box">
                        <img src="../assets/image/coms/right.png" alt="" class="btn_img" @click="imageClick('right')"
                             v-if="news_data.length!=0"/>
                    </div>
                </div>
            </div>
            <!--现场花絮-->
            <div class="wrap">
                <img src="../assets/image/news/gags_title.png" alt="" class="title_img" v-if="gags_img.length > 0"/>
                <div class="mb60 gags_wrap">
                    <template v-for="(item, index) in gags_img">
                        <img  :key="index" :src="item.thumb" @click="clk_link(item.link)" />
                    </template>
                </div>
                <!--官方账号-->
                <account></account>
            </div>

            <!-- 底部-->
            <copyright></copyright>
        </div>
    </div>
</template>

<script>
    import HomeHeader from "../components/blueheader";
    import copyright from "../components/copyright";
    import account from "../components/account";
    import lib_website from "../libs/lib_website";

    export default {
        name: "news",
        components: {
            HomeHeader,
            copyright,
            account
        },
        data() {
            return {
                gags_img: [], //花絮
                currPage: 1, //当前页
                news_data: [], //轮播数据
            }
        },

        methods: {
            // 获取城市
            getCity(city) {
                this.select_page(1)
                lib_website.ui(5, 1, this.init_gags)
            },
            select_page(page) {
                lib_website.news(1,page,2, this.init_news_list)
            },
            init_news_list(data) {
                console.log(data, '===')
                this.news_data = data
                // this.news_data = _array._convertArray(JSON.parse(JSON.stringify(data)),2)
            },

            init_gags(data) {
                this.gags_img = data
            },
            // 图片链接
            clk_link(link) {
                if(link) {
                    window.location.href = link
                }
            },
            convertArray(arr, columns) {
                return arr.flatMap((item, index) =>
                    index % columns ? [] : [arr.slice(index, index + columns)]
                );
            },

            imageClick(val) {
                if (val == 'right') {
                    // 请求下一页
                    this.currPage++;
                    this.select_page(this.currPage)
                    this.$refs.banner.next()
                } else {
                    // 请求上一页
                    this.currPage--;
                    this.select_page(this.currPage)
                    //点击左按钮切换至上一页走马灯
                    if(this.$refs.banner) {
                        this.$refs.banner.prev()
                    }
                }
            },

            clk_info(item) {
                console.log(item)
                this.$router.push(`/info?id=${item.id}`)
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/style/pages/news.less";
    @import "../assets/style/coms/banner.less";

</style>
